(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !window.DesignMode) return;
  try {
    
    $(".sizes-opener").on("click", function(){
        $(this).next(".size-selector").slideToggle();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !window.DesignMode) return;
  try {
    
    $('.image-gallery-slider').flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-video-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var videoElements = document.querySelectorAll('video');

    videoElements.forEach(function (videoElement) {
        console.log(videoElement);
      videoElement.controls = false;

      videoElement.addEventListener('play', function () {
        this.controls = false;
      });

      videoElement.addEventListener('pause', function () {
        this.controls = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        $('.product-recommendations--container').flickity({
          imagesLoaded: true,
          lazyLoad: true,
          cellAlign: 'left',
          wrapAround: true
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
